import { render, staticRenderFns } from "./ModalAddFile.vue?vue&type=template&id=c45eeb26&lang=pug&"
import script from "./ModalAddFile.vue?vue&type=script&lang=js&"
export * from "./ModalAddFile.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddFile.vue?vue&type=style&index=0&id=c45eeb26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports